export var InsuranceStatus;
(function (InsuranceStatus) {
    InsuranceStatus["PENDING"] = "PENDING";
    InsuranceStatus["COMPETITION_REVIEWED"] = "COMPETITION_REVIEWED";
    InsuranceStatus["APPROVED"] = "APPROVED";
    InsuranceStatus["REJECTED"] = "REJECTED";
})(InsuranceStatus || (InsuranceStatus = {}));
//# sourceMappingURL=insurance.js.map